import { Stack } from "@mui/material";
import { Text, Title } from "@src/appV2/redesign/system/ui-components";

import { PageHeaderTopRow } from "../../components/PageHeaderTopRow";
import { DotSeparatedText } from "../../Shift/WorkerShift/DotSeparatedText";
import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";
import { readableVisitTypeMapping } from "../constants";

export function VisitBottomSheetHeader() {
  const { visit, patient } = useInHomeVisitModalsDataContext();
  if (!visit || !patient) {
    return null;
  }

  return (
    <Stack
      alignItems="space-between"
      sx={(theme) => ({
        paddingTop: 6,
        paddingBottom: 7,
        px: 7,
        transition: theme.transitions.create(["background"]),
        background: theme.palette.homeHealth?.visit.gradient,
      })}
      spacing={4}
    >
      <PageHeaderTopRow sx={{ px: 0 }} />
      <Stack justifyContent="space-between" alignItems="flex-start" spacing={4}>
        <DotSeparatedText>
          <Text semibold variant="body1">
            {readableVisitTypeMapping[visit.attributes.type] ?? visit.attributes.type}
          </Text>
          <Text semibold variant="body1">
            {visit.attributes.workerReq}
          </Text>
        </DotSeparatedText>
        <Stack direction="row" spacing={2}>
          <Title component="h3" variant="h3">
            Patient:
          </Title>
          <Title component="h3" variant="h3" sx={{ wordBreak: "break-word" }}>
            {patient.attributes.externalPatientIdentifier}
          </Title>
        </Stack>
      </Stack>
    </Stack>
  );
}
